import { AliquotTax } from "../aliquot-tax";
import { Entity, Plan } from "../entity";

export class IntegratedAdmissionAppointmentPlan {
  Entity: Entity;
  Plan: Plan
  AliquotTax: AliquotTax;
}
